export const queryKeys = {
  FORMA: 'FORMA',
  GALLERY: 'GALLERY'
};
